import { createSelector } from "reselect";

import { getUserDepots } from "./user";

const DEFAULT_LONGTITUDE = -2.8695258;
const DEFAULT_LATITUDE = 54.0705897;
const DEFAULT_ZOOM = 11;
const NO_DEPOT_ZOOM = 5;

export const getAppState = (state) => state.app;

export const getSelectedDepot = createSelector(
  getAppState,
  ({ selectedDepot }) => selectedDepot
);

export const getSelectedDepotLocation = createSelector(
  getUserDepots,
  getSelectedDepot,
  (depots, selectedDepot) => {
    const depot = depots.find(({ depotCode }) => depotCode === selectedDepot);

    if (!depots.length || !selectedDepot || !depot) {
      return {
        coordinates: [DEFAULT_LONGTITUDE, DEFAULT_LATITUDE],
        zoom: [NO_DEPOT_ZOOM],
      };
    }

    return {
      coordinates: [depot.longitude, depot.latitude],
      zoom: [DEFAULT_ZOOM],
    };
  }
);
